import {LegacyCampus} from "@/shared/legacyTypes/fetchCampusTypes";

export enum TutionMonetaryValueKeys {
	REGISTRATION_FEE = "registration_fee",
	CURRICULUM_FEE = "curriculum_fee",
	SUMMER_TUITION_FEE = "summer_tuition_fee",
	TRIMESTERLY_TUITION_FEE = "trimesterly_tuition_fee",
	DISPLAY_TUITION_FEE = "display_tuition_fee",
}

export enum TuitionStringValuesKeys {
	EMAIL = "email",
}

export type TuitionValuesKeys =
	| TutionMonetaryValueKeys
	| TuitionStringValuesKeys;

export const tuitionMonetaryValueKeys = Object.values(TutionMonetaryValueKeys);

export const tuitionStringValuesKeys = Object.values(TuitionStringValuesKeys);

export const tuitionValuesKeys = [
	...tuitionMonetaryValueKeys,
	...tuitionStringValuesKeys,
];

export type TuitionValues = Pick<LegacyCampus, TuitionValuesKeys>;
